export const nluAutomateTooltip = 'Blits will periodically test all compatible recognizers with your bot language and choose the best recognizer for your case.'
